import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-fotolavoribricobravo',
  templateUrl: './fotolavoribricobravo.component.html',
  styleUrls: ['./fotolavoribricobravo.component.css']
})
export class FotolavoribricobravoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
